
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 import { SkyFlexcol as SkyFlexcolElement } from '@sky.ui/core/sky-flexcol';
 
 
 
 

 
 export const SkyFlexcol = createComponent({
   displayName: 'SkyFlexcol',
   react: React,
   tagName: 'sky-flexcol',
   elementClass: SkyFlexcolElement,
   events: {
     
   }
  });
export type * from '@sky.ui/core/sky-flexcol';
